import { render, staticRenderFns } from "./LogSistema.vue?vue&type=template&id=8a386216&"
import script from "./LogSistema.vue?vue&type=script&lang=js&"
export * from "./LogSistema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports